module.exports = __webpack_public_path__ + "img/GENERAL-SWIFT-BOOSTER-GREEN-3.9dc50648.jpg";